import React, { useContext } from 'react';
import './Expert.scss';
import { BsFillCheckCircleFill } from "react-icons/bs";
import expertImg from '../../assets/newmonaassets/image_ecem.jpg';
import { LanguageContext } from '../../context/LanguageContext';

const Expert = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className="expert-section" data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="expert-img">
                            <img src={expertImg} alt={t('altText.doctorExamination')} />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="expert-content">
                            <span className="subtitle">{t('expert.sectionTitle')}</span>
                            <h2>{t('expert.title')}</h2>
                            <p>{t('expert.description')}</p>
                            <ul>
                                {t('expert.benefits').map((benefit, index) => (
                                    <li key={index}>
                                        <BsFillCheckCircleFill />
                                        {benefit}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expert;